import { ui } from "@/components/ui";
import { useRouterState } from "@tanstack/react-router";
import { cn } from "../../lib/utils";
import Spinner from "./Spinner";

export function RouterSpinner() {
	const isLoading = useRouterState({ select: (s) => s.status === "pending" });
	return (
		<ui.Card
			className={cn(
				"z-50 fixed top-[50svh] left-[50vw] h-[100px] w-[100px] translate-y-[-50px] translate-x-[-50px]",
				!isLoading && "hidden",
			)}
		>
			<ui.CardContent className="m-auto p-5 w-full h-full">
				<Spinner className="p-1 w-full h-full" />
			</ui.CardContent>
		</ui.Card>
	);
}
